/* Phone  - submission to Salesforce */
/*
Forms integrated:
/pages/phone-form
*/
var errorMsj = '';
var tradeOptions = null;
$(document).ready(function(){
	/* Submit to salesforvce */
	function submitToSalesforcePhone(){
		var firstName = $("input#firstnameField").val();
		var lastname = $("input#lastnameField").val();
		var f_email = $("input#emailField").val();
		var f_phone = $("input#phoneField").val();
		var f_country = $("select.country").val();
		var f_state = $("select.select-state").val();
		var f_zip = $("input#zipField").val();
		var f_company = $("input#companyField").val();
      	var sf_trade_pricing = ( $('input#tradeApproval').val() === 'TRUE' ? "Yes" : "No");
		var sf_tax_id = $('input#TaxIdField').val();
      	var sf_title = $('input#titleField').val();
      	var sf_is_trade_request = $('input#isTradeRequest').val();
      
		var sf_landingPage = $("input.landing-page-url").val();
		var sf_keyword = $("input.keyword").val();
		var sf_gclid = $("input.gclid").val();
		var sf_bindId = $("input.bind-id").val();
		var sf_productType = $("input.product-type").val();
		var sf_leadSource = $("input.lead-source").val();
		var sf_campaignId = $("input.campaign-id").val();
		var sf_dclid = $("input.dclid").val();
		var sf_referrerDomain = $("input.referrer-domain").val();
		var sf_campaignContent = $("input.campaign-content").val();
		var sf_leadMedium = $("input.lead-medium").val();
      	var sf_is_from_shopify = 1;
        var sf_comments = $(".contact-body").val();

      
      	// Mailchimp Campaign Name
      	if (getCookie("ct") != "")
        {
        	sf_leadSource 		= getCookie("ct");
        }
      
        // Mailchimp ID for the campaign that generated the link
      	if (getCookie("mc_cid") != "")
        {        	
          	sf_campaignContent 	= getCookie("mc_cid");
        }
      
      	// unique Mailchimp ID that identifies the recipient’s email address
      	if (getCookie("mc_eid") != "")
        {
        	sf_leadMedium 		= getCookie("mc_eid");	
        }
      
      
      	// Google Campaign info
      	if (getCookie("utm_source") != "")
        {
        	sf_leadSource 		= getCookie("utm_source");
        }
      
      	if (getCookie("utm_campaign") != "")
        {        	
          	sf_campaignContent 	= getCookie("utm_campaign");
        }
      
      	if (getCookie("utm_medium") != "")
        {
        	sf_leadMedium 		= getCookie("utm_medium");	
        }
      
      

		var formData = { 
			oid: "00D700000008Q49",
			retURL: "https://kb2018.myshopify.com/pages/test-thank-you-page",
			"00N0g000003MsOv": sf_is_from_shopify,
			"00N0g000003Mrqy": sf_landingPage,
			"00N0g000003Mrr3": sf_keyword,
			"00N0g000003Mrr8": sf_gclid,
			"00N0g000003MrrD": sf_bindId,
			"00N0g000003MrrI": sf_productType,
			"00N70000001lU8u": sf_campaignId,
			"00N0g000003MsFP": sf_dclid,
			"00N0g000003MsFU": sf_referrerDomain,
			"00N0g000003MsFZ": sf_campaignContent,
			"00N0g000003MsFe": sf_leadMedium,        
			// "00N0g000003MrrN": sf_tax_id,
			"00N0g000003hvkX": sf_trade_pricing,
			"00N0g000003MsHG": "Phone Form",
          	// "00N0g000003hxzt": sf_is_trade_request,
			lead_source: sf_leadSource,
			first_name: firstName, 
			last_name: lastname,
			email: f_email, 
			phone: f_phone,
			state: f_state,
			zip: f_zip,
			country: f_country,
			company: f_company,
          	title: sf_title,
            "00N0g000003V6bT" : sf_comments,
		}
		console.log('Submitting to Salesforce - Phone Form');
      	console.log(formData);
		$.ajax({
		  type: "POST",
		  url: 'https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8',
		  data: formData,
		  success: afterSubmissionPhone,
		  error: afterSubmissionPhone,
		  dataType: 'json',
		  crossDomain : true,
		});	
	}
  
    $(".salesforce-integration-phone form #phone_btn").click(function(e){
          e.preventDefault();
          isFormValid = validateForm();
          if(isFormValid){
            showErrors(false);
            submitToSalesforcePhone();
            // alert('good!');
            /*
            ga('send', {
              hitType: 'event',
              eventCategory: 'Products',
              eventAction: 'Submitted',
              eventLabel: 'Get a Quote'
            });
 			*/           
          }else{
            showErrors(true);
            // alert('bad!');
          }
    });
	
    /* **************** */
	/* Helper functions */
	/* **************** */
	function validateForm(){
		isValid = false;
      	firstNameField = $("form#contact_form input#firstnameField").val();
      	lastNameField = $("form#contact_form input#lastnameField").val();
		emailField = $("form#contact_form input#emailField").val();
		emailValidation = validateEmail(emailField);
      	phoneField = $("form#contact_form input#phoneField").val();
      	shippingAddress = $("form#contact_form input#shippingField").val();
      	city = $("form#contact_form input#cityField").val();
      	stateField = $("form#contact_form input#stateField").val();
      	zipcode = $("form#contact_form input#zipField").val();
      
		if(emailValidation && firstNameField && lastNameField && phoneField && stateField && zipcode){
			isValid = true;
		}
		return isValid;
	}

	function validateEmail(email){
		result = false;
		rule = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
		if (rule.test(email)){
			return true;
		}
		return result;
	}

	function showErrors(show){
      	errorMsj = 'Please fill out the reuired fields.<br/>Make sure to enter a valid email address.';
		if(show){
			$("div#formErrors").html(errorMsj);
		}else{
			$("div#formErrors").html('');
		}	
	}
	
	function afterSubmissionPhone(data){
		console.log("Submitting to Shopify");
      	contactForm = $(".salesforce-integration-phone form#contact_form");
      	contactForm.submit();
	}
  
  	
});	